import SampleBotController from '../controllers/SampleBotController';
import commonHandler from '../errorHandlers/common-handler';
import CrudActionContainer from './CrudActionContainer';

class SampleBotCRUDActions extends CrudActionContainer {
  constructor() {
    super('SAMPLEBOTS');
  }

  retrieveAll() {
    return async dispatch => {
      try {
        dispatch(this.busy(this.retrieveAllAction));
        const response = await SampleBotController.getAll();
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }
}

const sampleBotCRUDActions = new SampleBotCRUDActions();

export default sampleBotCRUDActions;
